export default function Section(props){

  let children = [];
  if(props.titles !== undefined){
    for(let i = 0; i < props.titles.length; i ++)
    children.push(
      <div key={i} className="mb-10">
        <p className="mb-4 text-sm font-semibold lg:text-xl text-hover">{props.titles[i]}</p>
        <p className="text-xs lg:text-base"
        dangerouslySetInnerHTML={{__html:props.comments[i]}}></p>
      </div>
    )
  }

  const comment = props.comment!==undefined ? (
    <p className="text-xs text-center text-gray-600 lg:text-base" 
      dangerouslySetInnerHTML={{__html:props.comment}}></p>
  ):null
  
  return (
    <div className={`${props.className} flex flex-col mt-10 mb-5 lg:mt-40 lg:mb-10`}>
      <div className="flex justify-center mb-14">
        <p className="text-2xl lg:text-5xl">{props.title}</p>
      </div>
      <div className="flex flex-col">
        {children}
        {comment}
      </div>
    </div>
  );
}